import React from "react"

// Animated backdrop for the dark "Purple, Orange, and Dark" theme.
// Deep-charcoal base, slowly drifting orange + purple orbs, a faint
// dot-grid for texture, and a soft vignette to keep center content
// readable. Colors map to the dark palette:
//   orange: #FF6B00 / #E65100
//   purple: #7B2CBF / #3C096C
const BLOBS = [
  // Top-left orange glow
  { style: { background: "#FF6B00", opacity: 0.45 }, className: "top-[-12%] left-[-10%] w-[46vw] h-[46vw]", dur: "22s", delay: "0s" },
  // Purple bloom upper-right
  { style: { background: "#7B2CBF", opacity: 0.55 }, className: "top-[2%] right-[-14%] w-[40vw] h-[40vw]", dur: "26s", delay: "-7s" },
  // Burnt-orange mid-left
  { style: { background: "#E65100", opacity: 0.4 }, className: "top-[40%] left-[8%] w-[28vw] h-[28vw]", dur: "24s", delay: "-5s" },
  // Deep purple lower-center
  { style: { background: "#3C096C", opacity: 0.65 }, className: "bottom-[-12%] left-[20%] w-[44vw] h-[44vw]", dur: "30s", delay: "-12s" },
  // Orange spot lower-right
  { style: { background: "#FF6B00", opacity: 0.35 }, className: "bottom-[2%] right-[4%] w-[32vw] h-[32vw]", dur: "21s", delay: "-3s" },
]

export default function MainBackground({ className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      {/* Deep charcoal base */}
      <div className="absolute inset-0 bg-canvas" />

      {/* Drifting orange + purple orbs */}
      <div className="absolute inset-0">
        {BLOBS.map((b, i) => (
          <div
            key={i}
            className={`absolute rounded-full blur-3xl animate-blob-float ${b.className}`}
            style={{ ...b.style, animationDuration: b.dur, animationDelay: b.delay }}
          />
        ))}
      </div>

      {/* Grid: lines + intersection dots in one layer at low opacity;
          diagonals in a separate layer so they can sit at 0.3 opacity. */}
      <div
        className="absolute inset-0 opacity-[0.1]"
        style={{
          backgroundImage: [
            "radial-gradient(circle at 24px 24px, rgba(255,255,255,1) 3.5px, transparent 4.2px)",
            "radial-gradient(circle at 24px 24px, rgba(255,255,255,1) 1.75px, transparent 2.2px)",
            "linear-gradient(to right, rgba(255,255,255,0.5) 1px, transparent 1px)",
            "linear-gradient(to bottom, rgba(255,255,255,0.5) 1px, transparent 1px)",
          ].join(", "),
          backgroundSize: "192px 192px, 48px 48px, 48px 48px, 48px 48px",
          backgroundPosition: "0 0, 0 0, 24px 0, 0 24px",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.1]"
        style={{
          backgroundImage: [
            // Diagonal ╲ across each 8-block square (384px tile).
            "linear-gradient(135deg, transparent calc(50% - 0.6px), rgba(255,255,255,1) 50%, transparent calc(50% + 0.6px))",
            // Diagonal ╱ across each 8-block square.
            "linear-gradient(45deg, transparent calc(50% - 0.6px), rgba(255,255,255,1) 50%, transparent calc(50% + 0.6px))",
          ].join(", "),
          backgroundSize: "384px 384px, 384px 384px",
          backgroundPosition: "24px 24px, 24px 24px",
        }}
      />

      {/* Vignette so content stays readable on top */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_30%,rgba(0,0,0,0.45)_100%)]" />
    </div>
  )
}

export const AldooComponent = {
  id: "MainBackground",
  component: MainBackground,
  description: "Animated backdrop for the upload landing — a testbed for background treatments (default: lava-lamp gradient blobs).",
  input: {},
}
